<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import { closestSelector } from '../../../commonjs/helpers';
    import LinksMixin from "../../../author/pagesbuilder/mixins/LinksMixin";

    export default {
        name: "Element",
        mixins: [LinksMixin],
        data () {
            return {
                elementNode: null, //js node of the element that this class was created for
                elementType: "element",
                myIdName : "elementId",
                elementId: "",
                sectionNode: null, //holds the node of the section the element exists in
                sectionId: "", //holds the id of the section the element exists in
                megamenuWrapper : null,
                megamenuWrapperId : "",
                myButtonWrapper : null,
                myButtonWrapperId : "",
                megamenuComponentWrapperId : "",
                nestedComponentIds: [], // array with the ids of all the dynamic components that exist inside the element
                nestedElementIds: [],// array with the ids of all the elements that exist inside the element
            }
        },
        props : {
            registrationData: {
                type: Object
            }
        },
        computed: {
            ...mapState('elements',[
                'elementsData',
            ]),
            ...mapGetters('UiInteractions',[
                'hoveredNodeState',
            ]),
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    linkData: {},
                    visibility: ""
                }
            },
            myNode () {
                return this.elementNode;
            },
            myState () {
                return this.elementStates[this.elementId] ? this.elementStates[this.elementId] : {};
            },
            myNodeType () {
                return this.elementType;
            },
            elementData () {
                let dataToReturn = {};

                if (this.hasContext("school-topbar")) {

                    dataToReturn =  this.schoolTopbarData &&
                                    this.schoolTopbarData[this.topbarStatus] &&
                                    this.schoolTopbarData[this.topbarStatus].elements &&
                                    this.schoolTopbarData[this.topbarStatus].elements[this.elementId] ?
                                    this.schoolTopbarData[this.topbarStatus].elements[this.elementId] : {};

                } else if (this.hasContext("page-topbar")) {

                    dataToReturn =  this.pageTopbarData &&
                                    this.pageTopbarData[this.topbarStatus] &&
                                    this.pageTopbarData[this.topbarStatus].elements &&
                                    this.pageTopbarData[this.topbarStatus].elements[this.elementId] ?
                                    this.pageTopbarData[this.topbarStatus].elements[this.elementId] : {};

                } else if (this.hasContext("schoolFooter")) {

                    dataToReturn =  this.schoolFooterData &&
                                    this.schoolFooterData[this.footerStatus] &&
                                    this.schoolFooterData[this.footerStatus].elements &&
                                    this.schoolFooterData[this.footerStatus].elements[this.elementId] ?
                                    this.schoolFooterData[this.footerStatus].elements[this.elementId] : {};

                } else if (this.hasContext("pageFooter")) {

                    dataToReturn =  this.pageFooterData &&
                                    this.pageFooterData[this.footerStatus] &&
                                    this.pageFooterData[this.footerStatus].elements &&
                                    this.pageFooterData[this.footerStatus].elements[this.elementId] ?
                                    this.pageFooterData[this.footerStatus].elements[this.elementId] : {};

                } else {
                    dataToReturn = this.elementsData[this.elementId] ? this.elementsData[this.elementId] : {}
                }

                return dataToReturn;
            },
            myData () {
                return this.elementData;
            },
            myId () {
                return this.elementId;
            }
        },
        created () {
            this.elementCreated();
            // console.log("elementCreated : " , this.myId, this.myNodeType);
        },
        methods: {
            ...mapActions('elements',[
                'addElementState',
                'setElementData',
                'removeElementData',
                'editRegisteredElement'
            ]),            
            elementCreated () {

                this.handleRegistration().then( () => {
                    this.findMySection();
                    this.findMyMegamenuWrapper();
                    // this.findMyButtonWrapper();
                    this.setTopbarStatus();
                    this.setFooterStatus();
                    this.addElementState({
                        elementId: this.elementId,
                        state: this
                    });


                    this.$nextTick( () => {
                        let parent = this.getParent();
                        if(parent) {
                            this.bindElementToParent(parent, this);
                        }
                        // this.elementCreationCallback();
                    })
                })
            },
            elementContextBindingFinished () {},
            elementCreationCallback () {},
            acquireElementData () {
                if (typeof this.myData.elementId === "undefined") {                    
                    let propsData= {};
                    let defaultDataStructure = copyJson(this.getDefaultDataStructure);
                    if(this.myNode.hasAttribute('data-props')){
                        try{
                           propsData = JSON.parse(this.myNode.getAttribute('data-props'));                          
                           defaultDataStructure = {
                               ...defaultDataStructure,
                               ...propsData
                           }
                           
                           this.myNode.removeAttribute('data-props');
                           //debugger;
                        } catch(err) {
                            console.error('Json parse error', err);
                        };
                    }
                    
                    this.changeMyData(defaultDataStructure);                    
                                       
                    if(propsData.linkData){
                        //Todo move this away from here                        
                        this.$nextTick(()=>{
                            this.setLinkAttribute({attribute: 'forceRerender', value: true});
                        })
                        
                    }                  
                } else if (!Object.keys(this.getDefaultDataStructure).every(key => typeof this.myData[key] !== "undefined") ) {

                    let updatedValues = {};
                    Object.keys(this.getDefaultDataStructure).forEach( key => {
                        let defaultValue = this.getDefaultDataStructure[key];
                        if (typeof this.myData[key] === "undefined") {
                            updatedValues[key] = defaultValue;
                        }
                    })

                    this.changeMyData(updatedValues);
                }
            },
            findMyNode () {
                this.elementNode = document.querySelector("#" + this.elementId);
            },
            findMySection () {
                this.sectionNode = closestSelector(this.elementNode,"." + this.classSelectors.sectionNode);
                this.sectionId = this.sectionNode ? this.sectionNode.getAttribute("id") : "";
            },
            findMyButtonWrapper () {
                let sameContentWrapper = this.elementNode.closest('.' + this.classSelectors.sameContentWrapper);


                if (sameContentWrapper && sameContentWrapper.id &&  this.elementStates[sameContentWrapper.id] && this.elementStates[sameContentWrapper.id].elementType === "button-wrapper") {
                    this.myButtonWrapper = sameContentWrapper;
                    this.myButtonWrapperId = sameContentWrapper.id;
                }

            },
            changeMyData (newData) {
                if (!newData.elementId) {
                    newData.elementId = this.elementId;
                }

                this.setElementData(newData);
            },
            createElementId () {
                return "el_" + window.createTimeID();
            },
            createMyId () {
                return this.createElementId();
            },
            handleRegistration () {
                //tempId is used either when parsing DOM and finding an element without an ID or when inserting a new element from the elements list
                if (this.registrationData.tempId) {
                    return this.handleRegistrationWithTempId();
                } else if (this.registrationData.elementId) {
                    return this.handleRegistrationWithExistingId();
                }
            },
            handleRegistrationWithTempId () {

                let newElementId = this.createElementId();

                this.editRegisteredElement({
                    action: "replaceTempId",
                    tempId: this.registrationData.tempId,
                    elementId: newElementId
                });

                //when a section is found as a node without an id
                if (this.registrationData.elementNode && !this.registrationData.newElement) {

                    return new Promise( (resolve,reject) => {
                        this.elementNode = this.registrationData.elementNode;
                        this.elementNode.id = newElementId;
                        this.elementId = newElementId;
                        resolve();
                    })

                } else if (this.registrationData.elementNode && this.registrationData.newElement) {
                    return new Promise( (resolve,reject) => {
                        if (this.nodeStateToInsertAfter) {
                            this.nodeStateToInsertAfter.insertNode(this.registrationData.elementNode);
                        } else if (this.nodeStateToAppendIn) {
                            this.nodeStateToAppendIn.insertNode(this.registrationData.elementNode, "beforeend");

                        }

                        this.elementNode = this.registrationData.elementNode;
                        this.elementNode.id = newElementId;
                        this.elementId = newElementId;
                        resolve();
                    })
                } else if (this.registrationData.liquidFile){ //when we have no node but a reference to a liquid file to render

                    return this.acquireSectionTemplate(this.registrationData.liquidFile).then( elementHtml => {
                        let dummyWrapper = document.createElement("div");
                        dummyWrapper.innerHTML = elementHtml.trim();
                        let newElementNode = dummyWrapper.firstChild;
                        newElementNode.id = newElementId;

                        this.elementId = newElementId;
                        this.elementNode = newElementNode;
                    })
                }
            },
            handleRegistrationWithExistingId () {
                return new Promise( (resolve,reject) => {
                    this.elementNode = this.registrationData.elementNode;
                    this.elementId = this.elementNode.id;
                    resolve();
                })
            },
        },
    }
</script>
